import React from 'react'

const FounderMsg = ({ messageHeader, paragraphs }) => {
  return (
    <div className='px-16 max-[450px]:px-8 py-16 flex max-md:flex-wrap justify-center items-start gap-6'>
      <div className='w-1/2 max-md:w-full'>
        <p className='uppercase text-[30px] leading-[50px] font-bold'>{messageHeader}</p>
      </div>
      <div className='w-1/2 max-md:w-full flex flex-col gap-2'>
        {paragraphs.map((paragraph, index) => (
          <p key={index} className='text-[#7A7A7A] leading-[25px] text-[18px]'>{paragraph}</p>
        ))}
      </div>
    </div>
  )
}

export default FounderMsg